import Header from 'components/base/Header';
import { Link } from 'react-router-dom';


export default function Home() {

    const handleSunucunaEkleClick = () => {
        window.open('https://discord.com/api/oauth2/authorize?client_id=1002968219759423578&permissions=8&scope=bot%20applications.commands',
            "Sunucu Ekle",
            "width=500,height=650");
    }

    return (
        <>

            <main>
                <title>Ana Sayfa</title>
                <Header page="home" />
                <section className='items-center flex sm:px-5 px-0 max-w-screen-xl mx-auto mt-[100px]'>
                    <div className='flex items-center mx-auto flex-col'>
                        <div className='text-center max-w-[600px]'>
                            <h1 className="text-4xl font-bold">
                                <span className='text-indigo-500'>Disconomy</span> ile,<br></br> gerçekleştirilmiş ekonominin keyfini çıkar!
                            </h1>
                            <p className="mt-10 flex text-base text-black/60 dark:text-white/70">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget eros eu lectus viverra hendrerit. Nam euismod, nisi vel consectetur convallis, nisi nisl aliquet nunc, eget aliquam nisi nisl eget nisi.
                            </p>
                        </div>
                        <div className='flex mt-[70px]'>
                            <button onClick={handleSunucunaEkleClick} className='sm:mr-5 mr-1 flex items-center focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-opacity-50 bg-indigo-600 justify-center rounded-md text-white px-10 py-3 transition-all duration-200 cursor-pointer font-medium hover:bg-indigo-700 hover:shadow-xl active:shadow-none'>
                                Sunucuna ekle
                            </button>
                            <Link to="/support" target="_blank" >
                                <div className='flex items-center hover:underline text-zinc-900 dark:text-white/90 justify-center rounded-md px-10 py-3 transition-all duration-200 cursor-pointer font-medium'>
                                    Destek Sunucusu
                                </div>
                            </Link>
                        </div>
                    </div>
                </section>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                        <path className="fill-secondary-light dark:fill-secondary-dark" d="M0,160L60,144C120,128,240,96,360,112C480,128,600,192,720,202.7C840,213,960,171,1080,149.3C1200,128,1320,128,1380,128L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
                    </svg>
                </div>
                <div className='h-full w-full flex bg-secondary-light dark:bg-secondary-dark'>
                    <section className='items-center flex flex-col gap-24 sm:px-5 px-0 max-w-screen-xl mx-auto mt-[100px] pb-20'>
                        <div className="xl:ml-0 ml-6 flex flex-row justify-between gap-12">
                            <div>
                                <h1 className="max-w-lg text-2xl font-bold">
                                    <span className='underline decoration-indigo-500'>Disconomy</span> sayesinde, <br />Arkadaş edinmek çok basit!
                                </h1>
                                <p className="max-w-2xl mt-10 flex text-base text-black/60 dark:text-white/70">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget eros eu lectus viverra hendrerit. Nam euismod, nisi vel consectetur convallis, nisi nisl aliquet nunc, eget aliquam nisi nisl eget nisi.
                                </p>
                            </div>
                            <div className='md:flex 2xl:mr-0 mr-6 hidden min-w-[400px] flex-shrink-0 shadow-2xl shadow-black transition-images object-cover rounded-md'>
                                <img className="max-w-[400px]" src="/main.png" alt="" />
                            </div>
                        </div>
                        <div className="2xl:ml-0 ml-6 flex flex-row justify-between gap-12">
                            <div className='md:flex hidden min-w-[400px] flex-shrink-0 shadow-2xl shadow-black transition-images-reverse object-cover rounded-md'>
                                <img className="max-w-[400px]" src="/main.png" alt="" />
                            </div>
                            <div>
                                <h1 className="max-w-lg text-2xl font-bold">
                                    <span className='underline decoration-indigo-500'>Disconomy</span> sayesinde, <br />Arkadaş edinmek çok basit!
                                </h1>
                                <p className="max-w-2xl mt-10 flex text-base text-black/60 dark:text-white/70">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget eros eu lectus viverra hendrerit. Nam euismod, nisi vel consectetur convallis, nisi nisl aliquet nunc, eget aliquam nisi nisl eget nisi.
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
                <div className='z-10 bg-secondary-light dark:bg-secondary-dark'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                        <path className="fill-tertiary-light dark:fill-tertiary-dark" d="M0,96L80,122.7C160,149,320,203,480,202.7C640,203,800,149,960,128C1120,107,1280,117,1360,122.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
                    </svg>
                </div>
                <div className='h-[300px] w-full flex bg-tertiary-light dark:bg-tertiary-dark'>
                    <section className='items-center flex sm:px-5 px-0 max-w-screen-xl mx-auto mt-[100px]'>
                        Başka bir şey
                    </section>
                </div>
            </main>
        </>
    )
}
